import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import IconField from '../IconField';
import ReadonlyField from '../ReadonlyField';
import { resolveValue } from '../../../utils/fields';
import { extendedStateType } from '../../../types';
import { NO_STATE } from '../../../hooks/useExtendedState';

PrivilegedIconField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    state: extendedStateType,
};

PrivilegedIconField.defaultProps = {
    value: undefined,
    sufficientReadPrivileges: null,
    state: NO_STATE,
};

function PrivilegedIconField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        state,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const resolvedValue = resolveValue(value, state);
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <IconField
                    value={value}
                    state={state}
                    {...rest}
                />
            )
            : (
                canRead && (
                    <ReadonlyField
                        value={
                            resolvedValue && <FontAwesomeIcon icon={resolvedValue} />
                        }
                        state={state}
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedIconField;
